var colW = [40, 52, 65, 82, 95, 102, 120, 160, 200, 230, 250, 300];
var isUndefined = function (value) {
    return typeof value === 'undefined';
};
var nullToEmpty = function (value) {
    return [undefined, null].some(function (obj) { return obj === value; }) ? '' : String(value);
};
var generateRandomString = function (length, randomString) {
    if (length === void 0) { length = 12; }
    if (randomString === void 0) { randomString = ''; }
    var str = randomString;
    str += Math.random().toString(20).substr(2, length);
    return str.length >= length
        ? str.slice(0, length)
        : generateRandomString(length, str);
};
var timer;
export var timerDebounce = function (func, delay) {
    if (delay === void 0) { delay = 1000; }
    if (timer) {
        clearInterval(timer);
    }
    timer = setTimeout(func, delay);
};
var defaultTdStr = function (params) {
    var trans = params.column.trans, value = params.value;
    return trans ? trans(value) : nullToEmpty(value);
};
export { isUndefined, nullToEmpty, defaultTdStr, generateRandomString };
export default colW;
